import { render, staticRenderFns } from "./PopupShoppingCart.vue?vue&type=template&id=09d8e1f1&scoped=true"
import script from "./PopupShoppingCart.vue?vue&type=script&lang=js"
export * from "./PopupShoppingCart.vue?vue&type=script&lang=js"
import style0 from "./PopupShoppingCart.vue?vue&type=style&index=0&id=09d8e1f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8e1f1",
  null
  
)

export default component.exports